module.exports = __webpack_public_path__ + "img/1.11fa4475.jpg";